/* eslint-disable import/prefer-default-export */
export const REACT_APP_ENV = {
    production: 'production',
    staging: 'staging',
    dev: 'dev'
};